import React, { Component } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { bookingVessel } from '../../actions/dashboardAction'
import { Card, CardBody, CardHeader, Row, Col, Table, Badge } from 'reactstrap'
import { FORM_CONSIGNEE, FORM_SHIPPER, FORM_VESSEL_OP } from '../../actions/constant'

let userId = localStorage.getItem('tolaut@userId') || null
let form = localStorage.getItem('tolaut@form') || null

class LatestVesselBooking extends Component {
  componentDidMount() {
    let data = {
      limit: 5
    }

    if (form === FORM_SHIPPER) {
      data.shipper_id = userId
    }

    if (form === FORM_CONSIGNEE) {
      data.consignee_id = userId
    }

    if (form === FORM_VESSEL_OP) {
      data.operator_id = userId
    }

    this.props.bookingVessel(data)
  }

  render() {
    if (this.props.bookingVesselIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.bookingVesselHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12">
            <Card>
              <CardHeader className="text-center">
                <h5>Vessel Booking Terbaru</h5>
              </CardHeader>
              <CardBody className="p-0">
                {this.props.bookingVesselIsSuccess &&
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th className="text-center align-top">Kode Booking</th>
                        <th className="text-center align-top">Consignee</th>
                        <th className="text-center align-top">Trayek</th>
                        <th className="text-center align-top">Jumlah Container</th>
                        <th className="text-center align-top">Origin</th>
                        <th className="text-center align-top">Destination</th>
                        <th className="text-center align-top">ETD</th>
                        <th className="text-center align-top">ETA</th>
                        <th className="text-center align-top">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.bookingVesselData.data.map((item) => (
                        <tr key={item.id}>
                          <td className="text-center align-top">
                            <Link to={"booking/view/" + item.id}>{item.kode_booking}</Link>
                          </td>
                          <td className="text-center align-top">{item.consignee_name}</td>
                          <td className="text-center align-top">{item.kode_trayek} Voyage {item.voyage}</td>
                          <td className="text-center align-top">{item.total_diterima}</td>
                          <td className="text-center align-top">{item.nama_pelabuhan_asal}</td>
                          <td className="text-center align-top">{item.nama_pelabuhan_tujuan}</td>
                          <td className="text-center align-top">{moment(item.tanggal_berangkat).format('DD MMMM YYYY')}</td>
                          <td className="text-center align-top">{moment(item.tanggal_tiba).format('DD MMMM YYYY')}</td>
                          <td className="text-center align-top">
                            {item.status === 1 &&
                              <Badge color="primary">Baru</Badge>
                            }

                            {item.status === 2 &&
                              <Badge color="warning">Validasi Pemesanan</Badge>
                            }

                            {item.status === 3 &&
                              <Badge color="primary">Konfirmasi Pembayaran</Badge>
                            }

                            {item.status === 4 &&
                              <Badge color="danger">Ditolak</Badge>
                            }

                            {item.status === 5 &&
                              <Badge color="success">Selesai</Badge>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

LatestVesselBooking.propTypes = {
  bookingVesselIsSuccess: PropTypes.bool.isRequired,
  bookingVesselHasError: PropTypes.bool.isRequired,
  bookingVesselIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    bookingVesselData: state.dashboard.bookingVesselData,
    bookingVesselIsSuccess: state.dashboard.bookingVesselSuccess,
    bookingVesselHasError: state.dashboard.bookingVesselError,
    bookingVesselIsLoading: state.dashboard.bookingVesselLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    bookingVessel: (data) => dispatch(bookingVessel(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LatestVesselBooking)